import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Λογαριασμός',
  viewProfile: 'Προβολή προφίλ',
  roles: {
    admin: 'Διαχειριστής πλατφόρμας',
    companyAdmin: 'Διαχειριστής εταιρείας',
    departmentAdmin: 'Διαχειριστής/προπονητής τμήματος',
  },
  company: {
    label: 'Εταιρεία',
    switchTo: 'Εναλλαγή σε {{name}}',
  },
  accounts: {
    label: 'Άλλοι λογαριασμοί',
    switchTo: 'Εναλλαγή σε {{name}}',
    addAnother: 'Σύνδεση με άλλον λογαριασμό',
  },
  manage: 'Διαχείριση',
  settings: 'Προφίλ εταιρείας',
  language: 'Γλώσσα',
  theme: {
    label: 'Θέμα',
    light: 'Ανοιχτό',
    dark: 'Σκούρο',
    system: 'Σύστημα',
  },
  signOut: 'Αποσύνδεση',
  signOutAll: 'Αποσύνδεση από όλους τους λογαριασμούς',
};
